import { Skeleton, TableCell, TableRow } from '@mui/material';
import { HeaderLogs } from '../Logs';

interface Props {
    headers: HeaderLogs[];
    rows?: number;
}

const LogsTableSkeleton = ({ headers, rows = 10 }: Props) => (
    <>
        {Array.from({ length: rows }).map((_, i) => (
            <TableRow key={`skeleton-${i}`}>
                {headers.map((head) => (
                    <TableCell key={head.field}>
                        <Skeleton
                            variant="text"
                            width={head.field === 'sentAt' ? 120 : head.field === 'status' ? 60 : '80%'}
                            height={20}
                        />
                    </TableCell>
                ))}
            </TableRow>
        ))}
    </>
);

export default LogsTableSkeleton;